// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"nR","header":"nS","headline":"nT","closeIcon":"nU","modalCloseIcon":"nV"};